import ReactTooltip from "react-tooltip";
import React from "react";
import {Label} from "reactstrap";

export function getToolTipFormatedStr(title, str, id)
{
    if(str === null)
        return (<div><b>{title}</b>{':'}</div>);
    let list = str?.split(',');
    if(list?.length < 4)
    {
        return (
            <div><b>{title}</b>{': '}{list.map(desc => (
                desc
            )).join(',')}</div>
        )
    }
    else if(list?.length > 3) {
        return (
            <>
                <div data-tip data-for={'toolTip-'+title+'-'+id} style={{alignItems: 'left'}}>
                    <b>{title}</b>{': '}{list.slice(0,3).map(desc => (
                    desc)).join(',')}{' ...'}</div>
                <ReactTooltip id={'toolTip-'+title+'-'+id} place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                    {list.map(item => (
                        item
                    )).join(',')}
                </ReactTooltip>
            </>
        )
    }
}

export function getToolTipFormatedList(str)
{
    if(str === null)
        return '';
    let list = str.split('|');
    let len = 3 - list.length;
    if(list?.length < 4)
    {
        return (
            <>
                {
                    list.map(desc => (
                        <div>{desc}</div>
                    ))
                }
            </>
        )
    }
    else if(list?.length > 3) {
        return (
            <>
                <div>
                    {
                        list.slice(0,2).map(desc => (
                            <div style={{alignItems: 'left'}}>{desc}</div>))
                    }
                </div>
                <div style={{alignItems: 'left'}} data-tip data-for='toolTip-desc'>
                    {list[2]}{' ...'}</div>
                <ReactTooltip id='toolTip-desc' place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                    {list.map(item => (
                        <div>{item}</div>
                    ))}
                </ReactTooltip>
            </>
        )
    }
}

export function getToolTipFormatedStrB(title, str)
{
    if(str === null)
        return (<b>{title}:</b>);
    let list = str?.split(',');
    if(list?.length < 4)
    {
        return (
            <div><b>{title}{': '}</b>{list.map(desc => (
                desc
            )).join(',')}</div>
        )
    }
    else if(list?.length > 3) {
        return (
            <>
                <div data-tip data-for={'toolTip-'+title} style={{alignItems: 'left'}}>
                    <b>{title}{': '}</b>{list.slice(0,3).map(desc => (
                    desc)).join(',')}{' ...'}</div>
                <ReactTooltip id={'toolTip-'+title} place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                    {list.map(item => (
                        item
                    )).join(',')}
                </ReactTooltip>
            </>
        )
    }
}
export function getToolTipFormatedStrForIPSDT(title, str, project)
{
    if(str === null)
        return (<div></div>);
    let list = str?.split(',');
    if(list?.length === 1)
    {
        return (
            <span>{list.map(desc => (
                desc
            )).join(',')}</span>
        )
    }
    else if(list?.length > 1) {
        return (
            <>
                <div data-tip data-for={'toolTip-'+title+'-'+project.bpid+'-'+project.workOrder} style={{alignItems: 'left'}}>
                    {list.slice(0,1).map(desc => (
                    desc)).join(',')}{' ...'}</div>
                <ReactTooltip id={'toolTip-'+title+'-'+project.bpid+'-'+project.workOrder}
                              place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                    {list.map(item => (
                        item
                    )).join(',')}
                </ReactTooltip>
            </>
        )
    }
}